<template>
	<Container>
		<TopBar />
		<div class='load' v-if='loading'>
			<loading />
		</div>
		<div v-else class="content">	
			<LuckyDrawModal class='luckymodal' type='button' v-if='showLuckyModal' :luckyDraw='luckyDraw' :orderStatus='orderStatus'/>
			<div class="order-detail">
				<div class="order-head">
					<div :lg='8' class='order-left'>
						<p class="order-info">订单信息(Order Information)<span v-if='orderDetail.OptVipNo' v-text='forOrder(orderDetail)'></span></p>
						<div style="margin-left: 0.1rem;">
							<Row style="margin-top: 0.1rem;">
								<Col span='10'>订单编号(Order Number):</Col>
								<Col span='14'>{{orderDetail.OrderNo}}</Col>
							</Row>
							<Row style="margin-top: 0.1rem;">
								<Col span='10'>订单类型(Order Type):</Col>
								<Col span='14'>{{orderDetail.Catalog}}&nbsp;<template v-if='orderDetail.LRPTemplateType==11'>Template</template>&nbsp;<template v-if='orderDetail.VirtualFlag==20'>(赠品单)</template></Col>
							</Row>
							<Row style="margin-top: 0.1rem;">
								<Col span='10'>订单渠道(Order Channel):</Col>
								<Col span='14'>{{orderDetail.Channel}}</Col>
							</Row>
							<Row style="margin-top: 0.1rem;" v-if='orderDetail.VirtualFlag != 20'>
								<Col span='10'>支付类型(Payment Type):</Col>
								<Col span='14'>{{orderDetail.OrderType}}</Col>
							</Row>
							<Row style="margin-top: 0.1rem;" v-if='orderDetail.VirtualFlag != 20'>
								<Col span='10'>支付方式(Payment Method):</Col>
								<Col span='14'>{{channelType(orderDetail.PayChannel)}}</Col>
							</Row>
							<Row style="margin-top: 0.1rem;" v-if='getPromoCode()'>
								<Col span='10'>优惠(签到)码(Promo Code):</Col>
								<Col span='14'>{{(getPromoCode())}}</Col>
							</Row>
							<Row v-if='delivery.DeliveryStoreId == "501"' style="margin-top: 0.1rem;">
								<Col span='10'>收货地址(Delivery Address):</Col>
								<Col span='14'>{{address}}</Col>
								<Col span='10' v-if="canEditAddress">&nbsp;</Col>
								<Col span='14' v-if="canEditAddress">
									<span>
										修改地址 ( <span style="color: #BC86C8;text-decoration: underline;cursor: pointer;" @click='changeAwalysAddress'>选择常用地址</span> / <span style="color: #BC86C8;text-decoration: underline;cursor: pointer;" @click='changeAddress'>填写其他地址</span> )
									</span>
								</Col>
							</Row>
							<Row v-else style="margin-top: 0.1rem;">
								<Col span='10'>精油生活馆地址(Essential Oil Life Center Address):</Col>
								<Col span='14'>{{delivery.Address}}
								</Col>
							</Row>
							<Row v-if='delivery.PickUpCode && delivery.DeliveryStoreId != "501"' style="margin-top: 0.1rem;">
								<Col span='10'>提货码(Pick Up Code):</Col>
								<Col span='14'>{{delivery.PickUpCode}}
								</Col>
							</Row>
							<Row style="margin:0.1rem auto;">
								<Col span='10'>联系电话(TelePhone):</Col>
								<Col span='14'>{{delivery.MobliePhone}}</Col>
							</Row>
							<Row style="margin:0.1rem auto;">
								<Col span='10'>联系人(Receiver):</Col>
								<Col span='14'>{{delivery.Name}}</Col>
							</Row>
						</div>
					</div>
					<div class='track'>
						<!-- <div style="flex:1">
							<h3>物流信息(Logistics Information)</h3>
							<div class="track-detail">
								<p><span v-if='delivery.DeliveryStoreId == "501"'>{{delivery.ShippersName}}</span><span v-if='delivery.ExpressNo'>:{{delivery.ExpressNo}}</span> <Button class='show-btn' type='text' @click='showTrack=true' v-if='expressUrl&&delivery.DeliveryStoreId =="501"'>查看物流详情</Button></p>
								<p v-if="delivery.DeliveryStoreId && delivery.DeliveryStoreId != '501'">精油生活馆地址: {{delivery.Address}}</p>
								<Modal v-model='showTrack' title="物流详情" width='600'>
									<iframe :src="expressUrl" class="track-list"></iframe>
								</Modal>
							</div>
						</div> -->
						<div style="flex:1">
							<h3>发票信息(Invoice Information)</h3>
							<div class="track-detail">
								<p v-show="InvoiceLoad">{{InvoiceStatusText}}
									<a class='orderdetail-down' target="_blank" v-show="invoice.InvoiceStatus=='10' && SourceType  != 'Offline'" v-on:click="InvoinceDown">下载发票</a>&nbsp;&nbsp;
									<a class='orderdetail-down' target="_blank" v-show="CanCancelInvoice && SourceType  != 'Offline'" v-on:click="InvoinceCancel">作废发票</a>
									<Button class='show-btn' type='text' @click='showInvoice=true' v-show='canInvoice && SourceType  != "Offline"'>{{InvoiceStatusBtnText}}</Button>
								</p>
								<p style="font-size: 13px;">							
									<span style="color: #000;font-weight: bold;">注意事项：</span><br/>
									1.开票内容为产品明细，开票金额为实付金额，不含点数、积分及优惠券抵扣部分之金额<br/>
									2.订单完成1个月内可开具电子发票，如内容有误可在30天内修改，逾期无法处理<br/>
									3.开票后1工作日后可下载电子发票或发送邮箱，3个月内可重复下载，逾期失效<br/>
								</p>
								<Modal v-model='showInvoice' title="发票详情" width='600' ok-text="提交">
									<table class="Invoice-list">
										<tbody>
											<tr>
												<td class="Invoice-head"><span class="invoice-icon">*&nbsp;</span>类型:</td>
												<td class="Invoice-content">
													<span v-if="InvoiceStatus==0">
														<RadioGroup v-model="invoice.CompanyTypeText" type="button" size="large">
															<Radio label="个人"></Radio>
															<Radio label="企业"></Radio>
															<Radio label="机关事业单位"></Radio>
														</RadioGroup>
													</span>
													<span v-else>
														{{invoice.CompanyTypeText}}
													</span>
												</td>
												<td class="Invoice-right"></td>
											</tr>
											<tr>
												<td class="Invoice-head"><span class="invoice-icon">*&nbsp;</span>发票抬头:</td>
												<td class="Invoice-content">
													<template v-if="InvoiceStatus==0">
														<span v-if="isPersonal">
															<input type="text" class="ivu-input" v-model="invoice.InvoiceTitle" maxlength="50">
														</span>
														<span v-else>
															<Select v-model="invoice.InvoiceTitle" size="large">
																<Option  value="个人" key="个人">个人</Option>
																<Option  :value="userInfo.value.binding.name" :key="userInfo.value.binding.name">{{userInfo.value.binding.name}}</Option>
															</Select>
														</span>
													</template>
													<span v-else>
														{{invoice.InvoiceTitle}}
													</span>
													
												</td>
												<td></td>
											</tr>
											<tr v-show="InvoiceStatus==0 && isPersonal">
												<td class="Invoice-head"></td>
												<td>
													<Select v-model="invoiceCompany" size="large" @on-change="chooseInvoiceInfo()">
														<Option v-for="(item,index) in invoiceInfo" :value="index" :key="item.Id">{{ item.InvoiceTitle }}</Option>
													</Select>
												</td>
												<td class="Invoice-right">
													<Button type="primary" class="btn-invoiceDelete" @click="deleteInvoiceInfo">删除</Button></td>
											</tr>
											<tr v-show='isPersonal && showTaxPayerId'>
												<td class="Invoice-head"><span class="invoice-icon">*&nbsp;</span>纳税人识别号:</td>
												<td class="Invoice-content">
													<input type="text" class="ivu-input" v-model="invoice.TaxPayerId" v-if="InvoiceStatus==0" @blur="invoice.TaxPayerId=invoice.TaxPayerId.toUpperCase()"
													 maxlength="20">
													<!-- 1234567890 -->
													<span v-else>
														{{invoice.TaxPayerId}}
													</span>
												</td>
												<td class="Invoice-right" rowspan="6"></td>
											</tr>
											<tr v-show='isPersonal'>
												<td class="Invoice-head">地址:</td>
												<td class="Invoice-content">
													<!--上海-->
													<input type="text" class="ivu-input" v-model="invoice.Address" v-if="InvoiceStatus==0" maxlength="50">
													<!-- <RadioGroup v-model="invoice.Address" type="button" size="large" v-if="InvoiceStatus==0">
															<Radio label="上海" selected="true"></Radio>
														</RadioGroup> -->
													<span v-else>
														{{invoice.Address}}
													</span>
												</td>
											</tr>
											<tr v-show='isPersonal'>
												<td class="Invoice-head">电话:</td>
												<td class="Invoice-content">
													<input type="text" class="ivu-input" v-model="invoice.Phone" v-if="InvoiceStatus==0" maxlength="20">
													<!-- 15000000000 -->
													<span v-else>
														{{invoice.Phone}}
													</span>
												</td>
											</tr>
											<tr v-show='isPersonal'>
												<td class="Invoice-head">开户银行:</td>
												<td class="Invoice-content">
													<input type="text" class="ivu-input" v-model="invoice.BankName" v-if="InvoiceStatus==0" maxlength="20">
													<!-- 招商银行闵行支行 -->
													<span v-else>
														{{invoice.BankName}}
													</span>
												</td>
											</tr>
											<tr v-show='isPersonal'>
												<td class="Invoice-head">银行账号:</td>
												<td class="Invoice-content">
													<input type="text" class="ivu-input" v-model="invoice.BankNo" v-if="InvoiceStatus==0" maxlength="20">
													<!-- 60000000000000 -->
													<span v-else>
														{{invoice.BankNo}}
													</span>
												</td>
											</tr>
										</tbody>
									</table>
									<div slot="footer">
										<Button type="text" v-show="InvoiceStatus==0" v-on:click="cancelInvoice()">取消</Button>
										<Button type="primary" v-on:click="submitInvoice()">确定</Button>
									</div>
								</Modal>
								<Modal v-model='showInvoiceLink' title="发票文件" width='600'>
									您的发票文件已生成，点击确认后开始下载或者输入邮箱地址，我们将通过邮件发送给您。<br>
									<input type="text" class="ivu-input" v-model="InvoiceEmail" maxlength="50" placeholder="邮箱地址">
									<div slot="footer">
										<Button type="text" v-on:click="cancelInvoiceLink()">取消</Button>
										<a v-bind:href="pdfUrl" target="_blank" class="orderdetail-downLink ivu-btn ivu-btn-primary">下载</a>
										<Button type="text" v-on:click="PostInvoiceEmail()" class="ivu-btn ivu-btn-primary">发送邮件</Button>
									</div>
								</Modal>
								<Modal v-model='confirmInvoice' title="信息" width='600' ok-text="确认" @on-ok="postInvoice">
									请再次确认纳税人识别号是否正确
								</Modal>
							</div>
						</div>
					</div>
				</div>
				<div class="products" v-for="item in groups">
					<div v-if="Status(orderDetail.OrderStatus)" class="split" style="color: #AAAAAA;">{{Status(orderDetail.OrderStatus)}}</div>
					<div v-else-if="item.childCSNo && item.childCSNo != 'notshipped'" class="split">{{item.ShippersName}}：<span @click="Split(item.ExpressUrl)">({{item.childCSNo}})</span></div>
					<div v-else-if="item.childCSNo == 'notshipped'" class="split" style="color: #AAAAAA;">未发货</div>
					<Table class='orderTable' stripe :columns="columns" :data="item.products"></Table>
				</div>
				<Modal v-model='showTrack' title="物流详情" width='600'>
					<iframe :key='expressUrl' :src="expressUrl" class="track-list"></iframe>
				</Modal>
				<div style="width: 100%;text-align: right;padding: 30px 40px 0 0;" v-if="groups.length > 1"><Icon type="ios-alert-outline" size="16"/>为让您购买的商品能快速到达您的手中，故分为多个订单发货。</div>
				<Row style="background-color: #f3f3f3;margin-top: 0.5rem;">
					<Col :lg='{span:9, push:15}' class="fee">
					<Row>
						<Col :lg='12' :xs='18'>产品总价(Total amount)：</Col>
						<Col :lg='12' :xs='6'>¥{{orderDetail.ProductPrice?orderDetail.ProductPrice.toFixed(2):'0.00'}}</Col>
						<Col :lg='12' :xs='18'>产品点数(Total PV)：</Col>
						<Col :lg='12' :xs='6'>{{orderDetail.PValue?orderDetail.PValue.toFixed(2):'0.00'}}</Col>
						<Col :lg='12' :xs='18'>兑换点数(Redeem Point)：</Col>
						<Col :lg='12' :xs='6'>{{orderDetail.Point?orderDetail.Point.toFixed(2):'0.00'}}</Col>
						<!-- <template v-if='showPT'>
							<Col :lg='12' :xs='18'>服务费：</Col>
							<Col :lg='12' :xs='6'>¥{{orderDetail.ServiceFee?orderDetail.ServiceFee.toFixed(2):'0.00'}}</Col>
						</template> -->
						<Col :lg='12' :xs='18'>配送费(Freight)：</Col>
						<Col :lg='12' :xs='6'>
						<div class="mdeliveryFemv" v-if='free>0'>
							<div style="color: rgb(255, 70, 29);border-color: rgb(255, 70, 29);">
								<p style="color: rgb(255, 70, 29);">免{{free.toFixed(2)}}</p>
							</div>
						</div>
						<p style="width:initial;float:left" class="ellipsis" :class="{add_x: free > 0, move_x:(sys_deliveryFee-free)>0}" v-text='resuldeliveryFee()'></p>
						</Col>
						
						<Col :lg='12' :xs='18' v-if="orderDetail.Discount">优惠券支付：</Col>
						<Col :lg='12' :xs='6' v-if="orderDetail.Discount"><span @click='openCoupon' :class='{clickable:usedCouponCodes.length}'>¥{{orderDetail.Discount.toFixed(2)}}</span></Col>
					
						<Col v-if="orderDetail.ABValue>0" :lg='12' :xs='18'>账户余额(Account Balance)：</Col>
						<Col v-if="orderDetail.ABValue>0" :lg='12' :xs='6'>¥{{orderDetail.ABValue?orderDetail.ABValue.toFixed(2):'0.00'}}</Col>
				
						
						<Col :lg='12' :xs='18' style='color:orange'>产品积分支付(Product Credits)：</Col>
						<Col :lg='12' :xs='6' style='color:orange'>¥{{orderDetail.ARValue?orderDetail.ARValue.toFixed(2):'0.00'}}</Col>
					
						<Col :lg='12' :xs='18' style='font-weight: bold;font-size: 14px;'>应支付金额 (SubTotal):</Col>
						<Col :lg='12' :xs='6' style='font-weight: bold;font-size: 14px;'>¥{{orderDetail.TotalPaid?orderDetail.TotalPaid.toFixed(2):'0.00'}}</Col>

					</Row>
					<Col span='24' style='margin-top: 30px;' v-if='(orderDetail.OrderStatus=="UnPay"||orderDetail.OrderStatus=="Paying")&&(orderDetail.OptVipNo==null||orderDetail.OptVipNo==vipNo)&&((orderDetail.Channel=="MyO"||orderDetail.Channel=="Manual"))&&orderDetail.VirtualFlag != 100'>
					<Button @click='gotoPay' size='large' type='primary' style='margin-right: 40px;font-size:0.15rem'>继续付款(Continue to pay)</Button>
					<Button @click='qxpay' size='large' type='primary' style='font-size:0.15rem'>取消订单(Cancel Order)</Button>
					</Col>
					</Col>
				</Row>
			</div>
		</div>
		<addressList ref="addresslist" @confirmaddress='confirmaddress' @chooseAddress='chooseAddress'></addressList>
		<editAddressView title='修改收货人' :editAddress='editAddress' :show='show' @confirm='asyncOK' @cancel='show=false' :loading='addressLoading'></editAddressView>
		<couponsView
			ref='couponsView' 
			:coupons='coupons' 
			:usedCoupons='usedCouponCodes'
			title='优惠券详情'
			:readonly='true'
		/>
	</Container>
</template>

<script>
import TopBar from "@/components/common/TopBar";
import loading from "@/components/order/loading";
import { api_methods } from "@/service/loadData";
import addressList from "@/components/order/addressList";
import editAddressView from "@/components/order/editAddressView";
import util from "@/config/util";
import LuckyDrawModal from '@/components/order/LuckyDrawModal'
import {RE_EMAIL} from '@/components/common/regex';
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import {
	couponsMixin,
} from "@/components/common/mixin";
import couponsView from '@/components/order/couponsView'
export default {
	data() {
		return {
			columns: [
				{
					key: "Name",
					renderHeader: (h, index) => {
						return h("div",{style:{textAlign:'left'}}, [
							h("div", null, "商品"),
							h("div", null, "Commodity")
						]);
					},
					render:(h,params) =>{
						let innerHtml = [h('div',{style:{textAlign:'left',paddingTop:'10px'}},params.row.Name)]
						if (params.row.PromoteName) {
							innerHtml.push(h('div',{style:{color:'#B176C5',textAlign:'left',padding:'5px 0 10px 0'}},params.row.PromoteName))
						}
						return h('div',innerHtml)
					}
				},
				{
					key: "UnitPrice",
					renderHeader: (h, index) => {
						return h("div", [
							h("div", null, "单价"),
							h("div", null, "Unit Price")
						]);
					}
				},
				{
					key: "UnitPV",
					renderHeader: (h, index) => {
						return h("div", [h("div", null, "PV")]);
					}
				},
				{
					key: "UnitPT",
					renderHeader: (h, index) => {
						return h("div", [
							h("div", null, "兑换点数"),
							h("div", null, "PT")
						]);
					},
					render: (h, params) => {
						let innerHtml =params.row.Point ? params.row.UnitPT :0
						return h("div", null, innerHtml);
					}
				},
				{
					key: "Quantity",
					renderHeader: (h, index) => {
						return h("div", [
							h("div", null, "数量"),
							h("div", null, "quantity")
						]);
					}
				},
				{
					key: "subTotal",
					renderHeader: (h, index) => {
						return h("div", [
							h("div", null, "金额小计"),
							h("div", null, "SubTotal")
						]);
					},
					render: (h, params) => {
						let innerHtml =
							params.row.Amount - params.row.Discount;
						return h("div", null, innerHtml);
					}
				},
				{
					key: "subTotal",
					renderHeader: (h, index) => {
						return h("div", [
							h("div", null, "兑换点数小计"),
							h("div", null, "PT Total")
						]);
					},
					render: (h, params) => {
						let innerHtml =params.row.Point
						return h("div", null, innerHtml);
					}
				}
			],

			products: [],
			delivery: {},
			expressUrl: null,
			sys_deliveryFee: 0,
			free: 0,
			from: "orders",
			showTrack: false,
			showInvoice: false,
			invoice: {
				TaxPayerId: "",
				InvoiceTitle: "个人",
				CompanyTypeText: "个人",
				CompanyType: "03",
				Address: "上海",
				Phone: "",
				BankName: "",
				BankNo: "",
				Email: "",
				ID: 0
			},
			orderInvoice: {},
			invoiceInfo: {},
			invoiceCompany: "",
			InvoiceLoad: false,
			CanCancelInvoice:false,
			showInvoiceLink: false,
			InvoiceEmail:'',
			pdfUrl: '',
			confirmInvoice: false,
			InvoiceStatusBtnText: "申请开具发票",
			loading: true,
			canInvoice: true,
			editAddress: {
				id: 0,
				name: null,
				province_id: null,
				moblie_phone: null,
				city_id: null,
				county_id: null,
				town_id: null,
				street: null,
				zip: null,
				is_default: "0",
				tag_type: "0",
				address_type: "1"
			},
			show: false,
			addressLoading: false,
			omsOrderDetail:{},
			orderStatus:{},
			orderDetail:{},
			groups:[],
			showTaxPayerId:true,
			caddress: {},
			luckyDraw: {},
			SourceType: ''
		};
	},
	created() {
		this.$nextTick(function() {
			this.initData();
			this.vipNo = this.getVipNo;
		});
	},
	mounted() {},
	watch: {
		'invoice.CompanyTypeText'(value) {
				this.invoice.CompanyType=this.CompanyType;
				if (this.InvoiceStatus == 0) {
					if (value == '个人') {
						this.invoice.InvoiceTitle = '个人';
						this.showTaxPayerId=true;
					}
					else if (value == '企业') {
						if (this.invoice.InvoiceTitle == '个人') {
							this.invoice.InvoiceTitle = this.userInfo.value.binding?.company?.company_name || '个人';
						}
						if (this.userInfo.value.binding.customer_type.toLowerCase() == 'vipbiz' || this.userInfo.value.binding.customer_type.toLowerCase() == 'sa') {
							if (this.invoice.InvoiceTitle == '') {
								this.invoice.InvoiceTitle = this.userInfo.value.binding?.company?.company_name || '';
							}
							if (this.invoice.Phone == '') {
								this.invoice.Phone = this.userInfo.value.binding.moblie_phone;
							}
							if (this.invoice.BankName == '') {
								this.invoice.BankName = this.userInfo.value.binding.bank.bank_name;
							}
							if (this.invoice.BankNo == '') {
								this.invoice.BankNo = this.userInfo.value.binding.bank.account_number;
							}
							if (this.invoice.Email == '') {
								this.invoice.Email = this.userInfo.value.binding.email;
							}
							if (this.invoice.Address == '上海' || this.invoice.Address == '') {
								this.invoice.Address = this.userInfo.value.binding?.company?.business_street || this.invoice.Address;
							}
						}
						else if (this.userInfo.value.binding.customer_type.toLowerCase() == 'pc') {
							if (this.invoice.Phone == '') {
								this.invoice.Phone = this.userInfo.value.binding.moblie_phone;
							}
						}
						this.showTaxPayerId=true;
					}
					else if(value == '机关事业单位'){
						this.showTaxPayerId=false;
					}
					else {
						if (this.invoice.InvoiceTitle == '个人') {
							this.invoice.InvoiceTitle = '';
						}
						this.showTaxPayerId=true;
					}
				}
			}
	},
	mixins: [couponsMixin],
	components: {
		TopBar,
		addressList,
		editAddressView,
		LuckyDrawModal,
		loading,
		couponsView,
	},
	computed: {
		...mapGetters(["getVipNo"]),
		...mapState({
			userInfo: state => state.common.wechatUserInfo,
			sysConfig: state => state.common.sysConfig
		}),
		address() {
			return `${this.delivery.ProvinceName||''} ${this.delivery.CityName||''} ${this.delivery.CountyName||''} ${this.delivery.TownName || ""} ${this.delivery.Street||''}`;
		},
		showLuckyModal(){
			let pv = parseInt(this.orderDetail.PValue)
			return pv >= this.luckyDraw.Keywords && 'Pay,Confirm'.indexOf(this.orderDetail.OrderStatus) != -1
		},
		actualPay() {
			let actualPay =
				parseFloat(this.order.grandTotal) -
				parseFloat(this.order.totalAr);
			return actualPay.toFixed(2);
		},
		showPT: function() {
			if (this.orderDetail.Placetime >= this.sysConfig.value.pt_endtime) {
				return false;
			} else {
				return true;
			}
		},
		canEditAddress() {
			if (this.orderDetail.VirtualFlag) {
				return false	
			}	
			let editable = true;
			if (
				this.orderDetail.OrderStatus == "Cancel" ||
				this.orderDetail.OrderStatus == "Close"
			) {
				editable = false;
			}
			if (this.orderDetail.Paytime) {
				let now = new Date();
				let payTime = util.formatDate.dateFromStr(
					this.orderDetail.Paytime
				);
				if (now - payTime > 1800000) {
					editable = false;
				}
			}
			
			return editable;
		},
		CompanyTypeText() {
				//01：企业  02：机关事业单位 03：个人  04：其它
				if (this.invoice.CompanyType == '01') {
					return '企业'
				}
				else if (this.invoice.CompanyType == '02') {
					return '机关事业单位'
				}
				else if (this.invoice.CompanyType == '03') {
					return '个人'
				}
				else if (this.invoice.CompanyType == '04') {
					return '其他'
				}
				return '个人'
		},
		CompanyType() {
			//01：企业  02：机关事业单位 03：个人  04：其它
			if (this.invoice.CompanyTypeText == '企业') {
				return '01'
			}
			else if (this.invoice.CompanyTypeText == '机关事业单位') {
				return '02'
			}
			else if (this.invoice.CompanyTypeText == '个人') {
				return '03'
			}
			else if (this.invoice.CompanyTypeText == '其他') {
				return '04'
			}
			return '03'
		},
		InvoiceStatus() {
			if (this.invoice.InvoiceStatus == "00" || this.invoice.InvoiceStatus == "10") {
				return 1;//发票开具中\已开具发票，直接显示发票信息，不能再次申请
			}
			else {
				return 0;
			}
		},
		InvoiceStatusText() {
			if (this.invoice.InvoiceStatus == "00") {
				return "发票开具中"
			}
			else if (this.invoice.InvoiceStatus == "10") {
				return "已开具发票"
			}
			else if (this.invoice.InvoiceStatus == "-1") {
				return "开票失败"//开票失败，显示上次开票信息，可以再次申请
			}
			else if (this.SourceType == "Offline") {
				return "已线下开票"
			}
			else{
				return "未开具发票";
			}
		},
		isPersonal() {
			if (this.invoice.CompanyType == '03') {
				return false;
			}
			else {
				return true;
			}
		}
	},
	methods: {
		...mapMutations(["SET_ORDERNN","CHOOSE_ADDRESS"]),
		...mapActions([
			"getWXOrderDetailAction",
			"getOrderInvoiceAction",
			"getInvoiceInfoAction",
			"postOrderInoviceAction",
			"postInvoiceInfoAction",
			"postDeleteInvoiceInfoAction",
			'GetInvoiceDownAction',
			'getInvoiceEmailAction',
			'GetInvoiceCancelAction',
			'postInvoiceEmailAction',
			"getOrderEncryptionAction",
			"changeOrderAddressAction",
			"postAddAddressAction",
			'getOMSOrderDetailAction',
			'getCustomerCouponsAction',
			'getTipDetailAction',
		]),
		openCoupon(){
			if(this.usedCouponCodes.length){
				this.$refs.couponsView.show();
			}
		},
		// 拆分订购产品和兑换产品，返回数组
		splitProduct(product,changeCount) {
			let changeItem = Object.assign({},product);
			changeItem.Point = changeCount * changeItem.UnitPT
			changeItem.Quantity = changeCount
			changeItem.Amount = 0
			changeItem.UnitPV = 0
			product.Quantity = product.Quantity - changeCount;
			product.Point = 0
			product.UnitPT = 0
			return changeItem
		},
		// 排序 优先展示仅优惠价格购买的产品，产品如果涉及点数兑换的放在所有仅优惠顾客价购买的产品列表后面
		// 若同一个产品兑换又购买，需要将兑换和购买分2行记录，同一产品排列在连续的2行，兑换的记录行展示在购买的记录之后；
		// 各类赠品放在订单明细最末端
		sortProduct(products) {
			let buys=[],//仅购买
				buysAndPts=[], //购买加兑换
				pts=[], //仅兑换
				promotions=[] //促销品
			for (var i = 0; i < products.length; i++) {
				let product = products[i],nextProduct = i< products.length-1 ? products[i+1]:{}
				if(product.PromoteName) {
					promotions.push(product)
				} else if(product.Point) {
					pts.push(product)
				} else if(product.Amount && nextProduct.Point && product.SKU == nextProduct.SKU) {
					buysAndPts.push(product,nextProduct)
					i++;
				} else {
					buys.push(product)
				}
			}
			return [...buys,...buysAndPts,...pts,...promotions]
		},
		async initData() {
			this.loading = true
			let orderno = this.$route.query.orderNo;
			// if(this.userInfo&&this.userInfo.value&&this.userInfo.value.binding){
			// 	if(this.userInfo.value.binding.user_id!=this.orderDetail.CustomerId){
			// 		this.$router.push("/order/orders");
			// 		return
			// 	}
			// }
			let response = await this.getWXOrderDetailAction(orderno);
			if (response) {
				this.delivery = response.delivery[0] || {};
				this.lrptType = this.delivery.LRPTemplateType
				var products = response.group || [];

				this.products = products.filter(u =>
					this.showProductPromote(u)
				);
				if (response.coupon && response.coupon.length) {
					this.usedCouponCodes = response.coupon.map(item=>item.CouponCode);
					this.coupons = await this.getCustomerCouponsAction();
				}
				let groups = [];
				let newGroup = {};
				let originGroupBySku = {};
				let isSplitDeliver = false //是否拆单
				this.products.forEach((item,index)=>{
					let childCSNo = item.childCSNo;
					if(!originGroupBySku[item.Id]){
						originGroupBySku[item.Id] = Object.assign({},item);
						originGroupBySku[item.Id].childCSNo = 'notshipped';
						originGroupBySku[item.Id].Sort = index
					}
					if(childCSNo) { //已拆单
						isSplitDeliver = true;
						// 计算未发货的数量
						originGroupBySku[item.Id].Quantity = originGroupBySku[item.Id].Quantity - item.Quantity1;
						// 重新生成新的对象，防止污染原有对象
						let assignItem = Object.assign({},item);
						assignItem.Quantity = item.Quantity1;
						let newItems = [assignItem]
						// 判断此拆单中是否有点数兑换产品
						if(assignItem.Point) {
							// 判断兑换数量是否大于未发货的产品数量
							let changeCount = item.Point / item.UnitPT - originGroupBySku[item.Id].Quantity
							if(changeCount > 0) {
								let quantity = assignItem.Quantity;
								let changeItem = this.splitProduct(assignItem,changeCount)
								originGroupBySku[item.Id].Point = originGroupBySku[item.Id].Point - changeItem.Point
								if(changeCount >= quantity) {
									newItems = [changeItem]
								} else {
									newItems.push(changeItem)
								}
							} else {
								assignItem.Point = 0
							}

						}
						
						if(newGroup[childCSNo]){
							newGroup[childCSNo].products.push(...newItems);
						} else {
							newGroup[childCSNo] = {
								products:newItems,
								childCSNo,
								ShippersName:assignItem.ShippersName,
								ExpressUrl:assignItem.ExpressUrl,
								DeliveryCode:assignItem.DeliveryCode,
							}
						}
					}
				})
				this.groups = Object.values(newGroup)
				this.groups.forEach(item=>item.products = this.sortProduct(item.products))
				let unShippedProducts = Object.values(originGroupBySku).filter(item=>item.Quantity >0).sort((a,b)=>{return a.Sort - b.Sort})
				// 拆分兑换产品和订购产品
				let newProducts = []
				unShippedProducts.forEach(item=>{
					let newItems = [item]
					let quantity = item.Quantity
					if(item.Point > 0) {
						let changeCount = item.Point / item.UnitPT
						item.Point = 0
						let changeItem = this.splitProduct(item,changeCount)
						if(changeCount >= quantity) {
							newItems = [changeItem]
						} else {
							newItems.push(changeItem)
						}
					}
					newProducts.push(...newItems)
				})

				if(newProducts.length) {
					let unShipped = {
						childCSNo: isSplitDeliver ? 'notshipped' : (response.delivery[0].ExpressNo || 'notshipped'),
						ShippersName:isSplitDeliver ? '' : response.delivery[0].ShippersName,
						ExpressUrl:isSplitDeliver ? '' : response.expressUrl,
						DeliveryCode:'',
						products:this.sortProduct(newProducts),
					}
					this.groups = [...this.groups,unShipped]
				}
				console.log(this.groups);
				this.expressUrl = response.expressUrl;
				this.orderDetail = response.detail[0]
			}
			if (this.orderDetail && this.orderDetail.PayChannel || this.orderDetail.orderId) {
				let response1 = await this.getOMSOrderDetailAction(orderno);
				if (response1 && response1.orderStatus) {
					this.omsOrderDetail = response1
					this.initDataInvoice()
				}
			}

			if ((this.orderDetail.DeliveryStoreId == "501" && !this.delivery.PromoCode &&this.orderDetail.VirtualFlag==0)||this.orderDetail.VirtualFlag==100) {
				//取系统设置配送费
				this.sys_deliveryFee = this.delivery.float_delivery_fee;
				this.free = this.sys_deliveryFee - this.orderDetail.ExpressFee;
			} else if (this.delivery.PromoCode) {
				this.sys_deliveryFee = this.orderDetail.ExpressFee;
				this.free = this.sys_deliveryFee - this.orderDetail.ExpressFee;
			}
			this.luckyDraw = await this.getTipDetailAction("PayMent_Lucky_Draw");
			this.orderStatus = {
				forVipNo:this.orderDetail.forVipNo,
				OrderNo:orderno,
				VipNo:this.getVipNo,
				Paytime:this.orderDetail.Paytime
			}
			this.loading = false
		},
		Status(item) {
			const OrderStatus = {
				"Cancel":"已取消",
				"Returned":"退货完成",
				"Returning":"退货中",
				"Disable":"已作废",
				"Disabling":'作废处理中',
			}
			return OrderStatus[item] || '';
		},
		showProductPromote(item) {
			if (item.ProductFlag != 1) {
				return true;
			} else {
				if (!this.orderDetail.Paytime) {
					return true;
				} else if (!item.PromoteEnd) {
					return true;
				} else if (item.PromoteEnd > this.orderDetail.Paytime) {
					return true;
				}
				return false;
			}
		},
		Split(url) {
			this.expressUrl = url;
			this.showTrack = true;
		},
		async gotoPay() {
			var res = await this.getOrderEncryptionAction(
				this.orderDetail.OrderNo
			);
			if (res) {
				this.SET_ORDERNN({
					orderno: res,
					os: this.orderDetail.OrderNo
				});
				this.$router.push("/order/confirm");
			}
		},
		async changeAddress() {
			this.editAddress = {
				id: 0,
				orderNo: this.orderDetail.OrderNo,
				name: this.delivery.Name,
				province_id: parseInt(this.delivery.Province),
				city_id: parseInt(this.delivery.City),
				county_id: parseInt(this.delivery.County),
				town_id: parseInt(this.delivery.Town),
				street: this.delivery.Street,
				zip: this.delivery.Zip,
				moblie_phone: this.delivery.MobliePhone,
				address_type: 2,
				tag_type: "",
				is_default: false,
				whetherAddress: false
			};
			this.show = true;
		},
		async asyncOK(address) {
			this.addressLoading = true;
			var obj = {
				Id: address.id,
				Name: address.name,
				MobliePhone: address.moblie_phone,
				Province: address.province_id,
				City: address.city_id,
				County: address.county_id,
				Town: address.town_id,
				Street: address.street,
				Zip: address.zip,
				AddressType: address.address_type,
				Tags: address.tag_type,
				IsDefault: address.is_default ? 1 : 0,
				CustomerId: this.userInfo.value.binding.user_id,
				orderNo: this.orderDetail.OrderNo,
				Remark: ""
			};
			obj.Street = obj.Street.replace(/[\s\S]/g,ch=>{
				let ascii = ch.charCodeAt();
				if (ascii == 10) return '';
				if (ascii == 13) return '';
				if (ascii == 8203) return '';
				if (ascii == 160) return ' ';
				return ch;
			});
			let response = await this.changeOrderAddressAction(obj);
			if (response > 0) {
				if (address.whetherAddress) {
					await this.postAddAddressAction(obj);
				}
				this.$Message.success("地址修改成功");
				this.delivery.Name = this.caddress.name;
				this.delivery.MobliePhone = this.caddress.moblie_phone;
				this.delivery.Province = this.caddress.province_id;
				this.delivery.City = this.caddress.city_id;
				this.delivery.County = this.caddress.county_id;
				this.delivery.Town = this.caddress.town_id;
				this.delivery.ProvinceName = this.caddress.province;
				this.delivery.CityName = this.caddress.city;
				this.delivery.CountyName = this.caddress.county;
				this.delivery.TownName = this.caddress.town;
				this.delivery.Street = this.caddress.street;
			} else {
				let message = "";
				if (response == -1) {
					message =
						"订单不存在或者订单已经发货或者已经取消不可以修改";
				} else if (response == -2) {
					message = "订单正在处理中，请稍后修改";
				} else {
					message = "地址修改失败";
				}
				this.$Message.error(message);
			}
			this.show = false;
			this.addressLoading = false;
		},
		async changeAwalysAddress() {
			this.$refs.addresslist.open();
		},
		async confirmaddress() {
			this.asyncOK(this.caddress);
			// this.editAddress = {
			// 	id: 0,
			// 	orderNo: this.$route.query.os,
			// 	name: this.caddress.name,
			// 	province_id: parseInt(this.caddress.province_id),
			// 	city_id: parseInt(this.caddress.city_id),
			// 	county_id: parseInt(this.caddress.county_id),
			// 	town_id: parseInt(this.caddress.town_id),
			// 	street: this.caddress.street,
			// 	zip: this.caddress.zip,
			// 	moblie_phone: this.caddress.moblie_phone,
			// 	address_type: 2,
			// 	tag_type: "",
			// 	is_default: false,
			// 	whetherAddress: false,
			// };
			// this.show = true;
		},
		chooseAddress(address) {
			this.CHOOSE_ADDRESS({ address, index: 0 });
			this.caddress = address;
		},
		qxpay() {
			this.$Modal.confirm({
				title: "取消订单",
				content: "确定要取消订单吗？",
				onOk: () => {
					api_methods
						.CancelOrder(
							this.getAccessToken,
							this.getUserId,
							this.orderDetail.OrderNo
						)
						.then(result => {
							if (
								result &&
								result.data &&
								result.data.value == 1
							) {
								this.$parent.reload = true;
								this.$router.go(-1);
							} else {
								this.$Modal.info({
									title: "信息",
									content: "订单取消失败"
								});
							}
						});
				}
			});
		},
		resuldeliveryFee() {
			var Fee = this.sys_deliveryFee - this.free;
			return Fee > 0
				? "¥" + Fee.toFixed(2)
				: "¥" + this.sys_deliveryFee.toFixed(2);
		},
		channelType(item) {
			item = item && item.toLowerCase();
			if (item == "wechat" || item == 'wechatofficialaccount') {
				return "微信(Wechat)";
			}
			if (item == "alipay" || item == 'alipayappsdk') {
				return "支付宝(AliPay)";
			}
			if (item == "llzf") {
				return "银联(Union Pay)";
			}
			if (item == "together") {
				return "聚合码银联支付";
			}
			if (item == "unionapp") {
				return "云闪付";
			}
			if (item == 'balancepay') {
				return "dō惠";
			}
			if(this.orderDetail.TotalPaid==0){
				return "账户余额支付";
			}
		},
		forOrder(item) {
			if (item.OptVipNo == this.getVipNo) {
				//帮别人下单
				return "协助顾客订购:" + this.passwordName(item.Name);
			}
			if (item.VipNo == this.getVipNo) {
				//别人帮我下单
				return this.passwordName(item.OptName) + "（协助下单）";
			}
		},
		passwordName(name) {
			var newName = "";
			if (name) {
				if (name.length > 2) {
					newName =
						name.charAt(0) + "*" + name.charAt(name.length - 1);
				} else {
					newName = name.charAt(0) + "*";
				}
			}
			return newName;
		},
		convertChannel(channel) {
				switch (channel.toLowerCase()) {
					case 'wx':
						return "微信订单"
					case 'wechat':
						return "微信订单"
					case 'oms':
						return "客服门店订单"
					case 'mg':
						return "网络订单"
					case 'myo':
						return 'MyO订单'
					case 'moblieapp':
						return 'MobileApp订单'
					default:
						return channel+'订单'
						break;
				}
			},
		// 开票相关
		async initDataInvoice() {
				this.CanCancelInvoice = false;

				//canInvoice
				if (this.omsOrderDetail.orderStatus == '30' || this.omsOrderDetail.channel == "HWG"|| this.orderDetail.VirtualFlag == 20) {
					//订单状态：作废，隐藏审核发票按钮
					this.canInvoice = false;
					return;
				}

				//判断订单是否超过30天
				var now = new Date();
				var DateAdd30 = new Date(now.getFullYear(), now.getMonth()- 1, now.getDate());
				//console.log('DateAdd30');
				//console.log(DateAdd30.getFullYear()+'-'+DateAdd30.getMonth()+'-'+DateAdd30.getDate())
				//var DateAdd30 = new Date();
				var createTime = Date.parse(this.omsOrderDetail.createTime.replace(/-/g, '/'));
				// var isEffective = false;
				// if (DateAdd30.getTime() <= createTime) {
				// 	isEffective = true;
				// }
				//var OpenDay=new Date(2018, 11, 16);
				console.log('Valid OpenDay')
				console.log(this.omsOrderDetail.createTime)
				var OpenDay=new Date(2018, 11, 16);
				if(createTime<OpenDay.getTime()){
					this.canInvoice = false;
					console.log('Valid OpenDay Close')
					return;
				}
				else{
					console.log('Valid OpenDay Open')
				}

				//查询申请的发票信息
				let orderno = this.$route.query.orderNo;
				let responseOrderInvoice = await this.getOrderInvoiceAction(orderno);
				console.log('发票申请信息');
				console.log(responseOrderInvoice);
				if (responseOrderInvoice) {
					if(responseOrderInvoice.Value2>0){
						this.canInvoice = false;
						return;
					}
					if (responseOrderInvoice.Value.length >= 1) {
						this.invoice = responseOrderInvoice.Value[0];
						this.invoice.CompanyTypeText=this.CompanyTypeText;
						this.InvoiceStatusBtnText = '查看发票详情'
						this.SourceType = responseOrderInvoice?.Value[0]?.SourceType
						var createTime = this.invoice.CreateTime ? Date.parse(this.invoice.CreateTime.replace(/-/g, '/')) : new Date(1900);						
						if (DateAdd30.getTime() <= createTime && this.invoice.InvoiceStatus=='10' && this.invoice.IsCancel==0) {
							this.CanCancelInvoice = true;
						}
						console.log('this.CanCancelInvoice:'+this.CanCancelInvoice)
					}
					else
					{
						this.invoice={
							TaxPayerId: '',
							InvoiceTitle: '个人',
							CompanyTypeText: '个人',
							CompanyType: '03',
							Address: '上海',
							Phone: '',
							BankName: '',
							BankNo: '',
							Email: '',
							InvoiceStatus: '0'
						}
						
						this.InvoiceStatusBtnText='申请开具发票'
					}
				}

				// if (this.InvoiceStatus == 0 && isEffective == false) {
				// 	//未提交过发票信息且超过订单时间30天，隐藏申请发票按钮
				// 	this.canInvoice = false;
				// 	return;
				// }

				if(this.InvoiceStatus == 0){
					//未开票时，查询发票抬头记录历史列表，文本框填充上次申请的记录
					let responseInvoiceInfo = await this.getInvoiceInfoAction(orderno);
					console.log('发票抬头记录历史列表');
					console.log(responseInvoiceInfo);
					if (responseInvoiceInfo) {
						this.invoiceInfo = responseInvoiceInfo;

						//初始化
						if (this.invoiceInfo.length != 0) {
							this.invoiceCompany = this.invoiceInfo.length - 1;

							// this.invoice.CompanyTypeText = '企业';
							// this.invoice.CompanyType = '01';
							this.chooseInvoiceInfo();
						}
					}
					console.log('开票状态');
					console.log(this.InvoiceStatus);
				}
				this.InvoiceLoad = true;//加载完成，显示发票模块
			},
			async cancelInvoice() {
				this.showInvoice = false;
			},
			async submitInvoice() {
				if (this.invoice.InvoiceTitle == '') {
					this.$Modal.info({
						title: '信息',
						content: '请填写发票抬头'
					});
					return;
				}
				// if (!/^[\u4e00-\u9fa5a-zA-Z0-9()（） ]+$/.test(this.invoice.InvoiceTitle)) {
				// 	this.$Modal.info({
				// 		title: '信息',
				// 		content: '发票抬头不能含有特殊字符，请确认后重新输入'
				// 	});
				// 	return;
				// }
				this.invoice.InvoiceTitle = this.invoice.InvoiceTitle.fulltoHalf()
				if (this.InvoiceStatus == 0) {
					let orderno = this.$route.query.orderNo;
					//验证纳税人识别号格式，排除个人和机关事业单位的类型
					if (this.invoice.CompanyType != '03' && this.invoice.CompanyType != '02' ) {
						if (this.invoice.TaxPayerId == '') {
							this.$Modal.info({
								title: '信息',
								content: '请填写纳税人识别号'
							});
							return;
						}
						if (this.invoice.TaxPayerId.length != 18 && this.invoice.TaxPayerId.length != 15) {
							//this.confirmInvoice=true;识别号错误允许提交
							this.$Modal.info({
								title: '信息',
								content: '您输入的纳税人识别号有误，请确认后重新输入'
							});
							return;
						}
						// var reg = /^[1-9]+[0-9]*]*$/; //判断字符串是否为数字 ，判断正整数用/^[1-9]+[0-9]*]*$/
						// if (!reg.test(this.invoice.TaxPayerId) && this.invoice.TaxPayerId.length == 15) {
						// 	this.$Modal.info({
						// 		title: '信息',
						// 		content: '您输入的纳税人识别号格式有误，请确认后重新输入'
						// 	});
						// 	return;
						// }
						var re = /^[0-9a-zA-Z]*$/g;  //判断字符串是否为数字和字母组合     //判断正整数 /^[1-9]+[0-9]*]*$/  
						if (!re.test(this.invoice.TaxPayerId)) {
							this.$Modal.info({
								title: '信息',
								content: '您输入的纳税人识别号格式有误，请确认后重新输入'
							});
							return;
						}
					}
					else{
						this.invoice.TaxPayerId='';//机关单位类型不需要纳税识别号
					}
					await this.postInvoice();
				}
				else{
					//查看模式，直接关闭
					this.showInvoice = false;
				}
			},
			async postInvoice() {
				let orderno = this.$route.query.orderNo;
				if (this.invoice.CompanyType != '03') {
					if (this.invoiceInfo.length < 10) {
						let responseInvoiceInfo = await this.postInvoiceInfoAction(this.invoice);
						console.log('保存发票抬头信息');
						console.log(responseInvoiceInfo);
					}
				}
				var argOrderInovice = {
					OrderNo: orderno,
					OriginalID: this.omsOrderDetail.originalID,
					OrderDate: this.omsOrderDetail.createTime,
					InvoiceAmount: this.omsOrderDetail.grandTotal,
					invoice: this.invoice
				}
				let responseOrderInovice = await this.postOrderInoviceAction(argOrderInovice);
				console.log('申请开发票');
				console.log(responseOrderInovice);
				if (responseOrderInovice.Result == 1) {
					//操作成功
					this.$Modal.info({
						title: '信息',
						content: responseOrderInovice.Remark
					});
					this.showInvoice = false;
					this.initDataInvoice()
				}
				else {
					if (responseOrderInovice.Remark) {
						//购货方纳税人识别号格式错误
						if (responseOrderInovice.Remark.indexOf('购货方纳税人识别号格式错误') >= 0) {
							this.$Modal.info({
								title: '信息',
								content: '购货方纳税人识别号格式错误'
							});
						}
						else {
							this.$Modal.info({
								title: '信息',
								content: responseOrderInovice.Remark
							});
							this.showInvoice = false;
							this.initDataInvoice()
						}
					}
					else {
						this.$Modal.info({
							title: '信息',
							content: responseOrderInovice.msg
						});
					}
				}
			},
			async chooseInvoiceInfo() {
				this.invoice.Address = this.invoiceInfo[this.invoiceCompany].Address;
				this.invoice.BankName = this.invoiceInfo[this.invoiceCompany].BankName;
				this.invoice.BankNo = this.invoiceInfo[this.invoiceCompany].BankNo;
				this.invoice.CompanyType = this.invoiceInfo[this.invoiceCompany].CompanyType;
				this.invoice.CompanyTypeText=this.CompanyTypeText;
				this.invoice.Email = this.invoiceInfo[this.invoiceCompany].Email;
				this.invoice.InvoiceTitle = this.invoiceInfo[this.invoiceCompany].InvoiceTitle;
				this.invoice.Phone = this.invoiceInfo[this.invoiceCompany].Phone;
				this.invoice.TaxPayerId = this.invoiceInfo[this.invoiceCompany].TaxPayerId;
				this.invoice.ID = this.invoiceInfo[this.invoiceCompany].ID;
			},
			async deleteInvoiceInfo() {
				let orderno = this.$route.query.orderNo;
				let response = await this.postDeleteInvoiceInfoAction(this.invoiceInfo[this.invoiceCompany].ID);
				console.log(response);
				if (response == 1) {
					//操作成功
					this.$Modal.info({
						title: '信息',
						content: '删除成功！'
					});
					//刷新发票抬头列表
					let responseInvoiceInfo = await this.getInvoiceInfoAction(orderno);
					console.log(responseInvoiceInfo);
					if (responseInvoiceInfo) {
						this.invoiceInfo = responseInvoiceInfo;
					}
				}
				else {
					this.$Modal.info({
						title: '信息',
						content: '删除失败！'
					});
				}

			},
			async InvoinceDown() {
				let orderno = this.$route.query.orderNo;
				let reponse = await this.GetInvoiceDownAction(orderno);
				if (reponse.code == 1) {
					//this.$router.push(reponse.pdfUrl);
					// this.$Modal.info({
					// 	title: '信息',
					// 	content: reponse.pdfUrl
					// });
					this.pdfUrl = reponse.pdfUrl;
					this.showInvoiceLink = true;

					//获取接收发票的邮箱地址
					
					let reponseEmail = await this.getInvoiceEmailAction();
					this.InvoiceEmail=reponseEmail
				}
				else {
					this.$Modal.info({
						title: '信息',
						content: reponse.message
					});
				}
			},
			async InvoinceCancel(){
				var _this=this
				this.$Modal.confirm({
					title: '信息',
					content: '发票作废后仅有一次重开机会，且重开的发票将无法作废，请谨慎操作！<br>请再次确认是否需要取消开具的发票？',
					loading:true,
					onOk: async () => {
						let reponse = await _this.GetInvoiceCancelAction(this.invoice.Id);
						if(reponse==1){
							_this.$Modal.info({
								title: '信息',
								content: '取消成功！'
							});
						}
						else{
							_this.$Modal.info({
								title: '信息',
								content: '取消失败！'
							});
						}
						await _this.initDataInvoice();
						_this.$Modal.remove();
					}
				});
			},
			cancelInvoiceLink() {
				this.showInvoiceLink = false;
			},
			async PostInvoiceEmail(){
				if (this.InvoiceEmail=='') {
					this.$Modal.info({
						title: '信息',
						content: '请输入邮箱地址！'
					});
					return;
				}

				if (!(RE_EMAIL.test(this.InvoiceEmail))) {
					this.$Modal.info({
						title: '信息',
						content: '邮箱格式不正确请重新输入！'
					});
					return;
				}
				var params={RecordId:this.invoice.Id,EmailAddress:this.InvoiceEmail}
				let reponse = await this.postInvoiceEmailAction(params);
				if(reponse){
					this.$Modal.info({
						title: '信息',
						content: '发送成功！'
					});
				}
				this.showInvoiceLink = false;
			},
			getPromoCode(){
				let group = this.products||[];
				var code=''
				group.forEach((item)=>{
					if(item.PromoCode){
						code=code+item.PromoCode+','
					}
				}) 
				if(code=='') return null
					return code.substring(0,code.length-1);
			}
	}
};
</script>

<style lang='scss' scoped>
@import "@/style/common";
@import "@/style/mixin";
.topbar {
	background-color: #f3f4f5;
	a {
		line-height: 40px;
		margin-left: 10.42vw;
		&:hover {
			color: $theme-color;
		}
	}
}
.load {
	position:fixed;
	top: 0;
	left:0;
	display:flex;
	width:100vw;
	height:100vh;
}
.content {
	padding-top: 10px;
	width: 80%;
	margin: auto;
	list-style: none;
	margin-bottom: 50px;
}
.order-head {
	border: 1px solid rgba(0,0,0,0.05);
	display: flex;
}
.order-detail {
	margin-top: 0.5rem;
}
.order-left {
	border-right: 1px solid rgba(0, 0, 0, 0.05);
	padding: 0;
	color: #666;
	background-color: #fbfbfb;
	font-size: 13px;
	flex:8;
}
.track {
	display:flex;
	flex:12;
	flex-direction: column;
}
.order-info,
.track h3 {
	border-bottom: 1px solid rgba(0, 0, 0, 0.05);
	line-height: 2;
	font-size: 15px;
	padding-left: 16px;
	background-color: #f5f5f5;
	span {
		float: right;
		padding-right: 5px;
		color: #3484e0;
	}
}
.track-detail {
	font-size: 15px;
	line-height: 2.5;
	padding-left: 16px;
	padding-top: 10px;
}

.products {
	margin-top: 0.5rem;
}
.split{
	width: 100%;
	color: #B176C5;
	font-size: 0.14rem;
	font-weight: bold;
	background: #F8F8F9;
	padding: 15px 40px 15px 0;
	display: flex;
	align-items: center;
	justify-content: flex-end;
	border-bottom: 1px solid #E9EBED;
	span{
		cursor: pointer;
		text-decoration: underline;
	}
}
.fee {
	line-height: 2;
	padding: 0.5rem 0;
	color: #666;
	font-size: 12px;
}
.add_x {
	text-decoration: line-through;
}
.move_x {
	text-decoration: none;
}
.mdeliveryFemv {
	display: flex;
	position: relative;
	//top: -24px;;
	left: 5px;
	text-align: center;
	display: inline-block;
	div {
		font-size: 14px;
		height: 20px;
		padding: 2.34px;
		border: 1px solid #666;
		border-radius: 7.03px;
		margin-right: 2.34px;
		transform: scale(0.8);
	}
	p {
		white-space: nowrap;
		line-height: 14px;
		font-size: 14px;
	}
}
.clickable {
	cursor: pointer;
	color: #BD8BCA;
	text-decoration: underline;
}
.show-btn {
	margin-left: 0.2rem;
	color:$theme-color;
}
.track-list {
	width: 100%;
	border: none;
	height: 350px;
}
.Invoice-list {
	line-height: 40px;
	font-size: 14px;
	width: 100%;
}
.Invoice-head {
	text-align: right;
	width: 25%;
	padding-right: 15px;
}
.Invoice-content {
	/*padding-right:20%*/
}
.Invoice-right {
	width: 20%;
}
.btn-invoiceDelete {
	float: left;
}
.invoice-icon {
	color: red;
}
.luckymodal {
	margin-top: 20px;
}
@media (max-width: 768px){
	.content {
		width: 95%;
	}
	.order-head {
		flex-direction: column;
	}
}
</style>